export const DEFAULT_PROFILE_COLOR = "#6C5CE7";

const HEX_COLOR_REGEX = /^#[0-9A-Fa-f]{6}$/;

export const isValidHexColor = (value: string): boolean => HEX_COLOR_REGEX.test(value.trim());

export const getContrastingTextColor = (hex: string): string => {
  if (!isValidHexColor(hex)) {
    return '#FFFFFF';
  }

  const normalized = hex.replace('#', '');
  const r = parseInt(normalized.substring(0, 2), 16);
  const g = parseInt(normalized.substring(2, 4), 16);
  const b = parseInt(normalized.substring(4, 6), 16);

  // Formula per W3C for perceived luminance
  const luminance = 0.299 * r + 0.587 * g + 0.114 * b;
  return luminance > 186 ? '#1F2933' : '#FFFFFF';
};
